import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type ReflectionBaseFragment = { id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string };

export const ReflectionBaseFragmentDoc = gql`
    fragment ReflectionBaseFragment on ProductSiteSpecificsType {
  id
  pk
  name
  shortName
  videoUrl
  slug
}
    `;